import { useEffect, useState } from "react";

/* eslint-disable react-hooks/exhaustive-deps */
import useMaster from "hook/useMaster";
import { showToast } from "utils/utility";
import { useAffiliateData } from "libs/data-access";
import { useApi } from "libs/data-access/src/api/useApi";
import { PAGINATION_ITEM_LIMIT } from "libs/data-access/constant";
import { IAffiliateGroupList, INewAffiliateGroup, TPaginationStatus } from "types";

interface IAffiliateListData {
  id: number;
  name: string;
  email: string;
  companyName: string;
};

const DefaultGroup: INewAffiliateGroup = {
  name: "",
  affiliateUsers: []
};

const useManageGroupB2B = () => {

  const {
    getAffiliateData
  } = useAffiliateData();

  const {
    postData,
    putData,
    patchData
  } = useApi();

  const [loading, setLoading] = useState<boolean>(false);
  const [isLoadingIndex, setIsLoadingIndex] = useState<number | undefined>(undefined);

  const [modalType, setModalType] = useState<"CREATE" | "UPDATE">();

  const [affiliateList, setAffiliateList] = useState<IAffiliateListData[]>([]);
  const [groupList, setGroupList] = useState<IAffiliateGroupList[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<IAffiliateGroupList>();
  const [newGroup, setNewGroup] = useState<INewAffiliateGroup>(DefaultGroup);


  useEffect(() => {
    getGroupList("INITIAL_PAGE");
    getAffiliateList();
  }, []);

  useEffect(() => {
    if (selectedGroup) {
      setNewGroup({
        name: selectedGroup.name,
        affiliateUsers: selectedGroup.affiliateUsers?.map(e => e?.id)
      });
    } else {
      setNewGroup(DefaultGroup);
    };
  }, [selectedGroup]);


  // API CALLS
  const getAffiliateList = async () => {
    const response = await getAffiliateData(`/get-affiliate-details`);

    if (response.isSuccess) {
      // console.log("response of getting all affiliate list", response.data.data);
      setAffiliateList(response.data.data);
    } else {
      console.log("error in getting all affiliate list", response.error);

      if (response.status === 404) {
        showToast({
          type: "error",
          message: "No affiliate found!",
        });
      } else {
        showToast({
          type: "error",
          message: response.error.message || "Could not retrieve available affiliates!",
        });
      };
    };
  };


  const getGroupList = async (paginationAction: TPaginationStatus) => {
    const body = {
      paginationFilterRequest: {
        paginationAction: paginationAction,
        maxLimit: 100,
        id: null,
        sortingOrder: "ASC",
      },
      supplierId: 0,
    };

    const response = await postData(`affiliate-group/get-all`, body);
    if (response.isSuccess) {
      // console.log("response of getting all group list", response.data.data);
      setGroupList(response.data.data);
    } else {
      console.log("error in getting all group list", response.error);
    };
  };

  const createNewGroup = async () => {
    setLoading(true);
    const response = await postData(`affiliate-group/save`, newGroup);
    if (response.isSuccess) {
      showToast({
        type: "success",
        message: "Group created successfully",
      });
    }
    setLoading(false);
    setModalType(undefined);
  };

  const activeInactiveGroup = async (status: boolean, id: number, index: number) => {
    setIsLoadingIndex(index);
    const endpoint = status
      ? "affiliate-group/active-all"
      : "affiliate-group/inActive-all";
    const response = await patchData(`${endpoint}?ids=${id}`, {});
    if (response.isSuccess) {
      getGroupList("INITIAL_PAGE");
    }
    console.log("response of activeInactiveGroup", response);
    setIsLoadingIndex(undefined);
  };

  const updateAffiliates = async () => {
    setLoading(true);


    const response = await putData(
      `affiliate-group/update/${selectedGroup?.id}`,
      {
        name: newGroup.name,
        userIds: newGroup.affiliateUsers
      }
    );
    if (response.isSuccess) {
      getGroupList("INITIAL_PAGE");
      showToast({
        type: "success",
        message: "Group updated successfully",
      });
    }
    setLoading(false);
    setSelectedGroup(undefined)
    setModalType(undefined);
  };


  return {
    loading,
    isLoadingIndex,
    groupList,
    modalType,
    affiliateList,
    setModalType,
    createNewGroup,
    updateAffiliates,
    activeInactiveGroup,
    DefaultGroup,
    newGroup,
    setNewGroup,
    selectedGroup,
    setSelectedGroup,
  };
};

export default useManageGroupB2B;
